import withViewLoader from 'hoc/withViewLoader';

export const LegacyPage = withViewLoader(({ path, setLoading }) => {
	return (
		<object
			id='object--legacy-ims'
			height='90%'
			width='100%'
			data={path}
			title={'IMS ASP.NET page'}
			onLoad={() => setLoading(false)}
		/>
	);
});
